import React, { useEffect, useRef, useState } from "react";

/** Transición "puertas de la forja": dos planchas de metal cierran la pantalla,
 *  la luz del circuito recorre desde el centro hacia afuera y luego abren. */

let emit = null;

export function playForgeGate(opts = {}) {
  return new Promise((resolve) => {
    if (!emit) return resolve();
    emit({ ...opts, resolve });
  });
}

const RAYS = Array.from({ length: 18 }, (_, i) => i);

export const ForgeGateHost = () => {
  const [gate, setGate] = useState(null);
  const [phase, setPhase] = useState("idle");
  const timers = useRef([]);

  useEffect(() => {
    emit = (g) => { setPhase("closing"); setGate(g); };
    return () => { emit = null; };
  }, []);

  useEffect(() => {
    if (!gate) return;
    timers.current = [
      setTimeout(() => setPhase("sealed"), 820),
      setTimeout(() => { gate.resolve(); setPhase("opening"); }, 2600),
      setTimeout(() => { setGate(null); setPhase("idle"); }, 3550),
    ];
    return () => timers.current.forEach(clearTimeout);
  }, [gate]);

  if (!gate) return null;
  const sealed = phase === "sealed";

  return (
    <div className={`forge-gate forge-gate--${phase}`} data-testid="forge-gate" role="presentation">
      <div className="forge-door forge-door--left" />
      <div className="forge-door forge-door--right" />
      <div className="forge-seam" />

      <div className="forge-spark-layer" aria-hidden="true">
        <svg viewBox="0 0 1000 1000" preserveAspectRatio="xMidYMid slice" className="w-full h-full">
          {RAYS.map((i) => {
            const a = (i / RAYS.length) * Math.PI * 2;
            const x = 500 + Math.cos(a) * 900;
            const y = 500 + Math.sin(a) * 900;
            const mx = 500 + Math.cos(a) * 180 + (i % 2 ? 60 : -60);
            const my = 500 + Math.sin(a) * 180 + (i % 3 ? -40 : 40);
            return (
              <path key={i} d={`M500 500 L${mx} ${my} L${x} ${y}`} className="forge-spark"
                fill="none" strokeWidth="2"
                style={{ animationDelay: `${0.85 + (i % 6) * 0.11}s` }} />
            );
          })}
          <circle cx="500" cy="500" r="7" className="forge-core" />
        </svg>
      </div>

      <div className={`forge-gate-content ${sealed ? "is-on" : ""}`}>
        <img src="/logo-digital-forge.jpg" alt="Digital Forge" className="forge-gate-logo brand-hue"
          data-testid="forge-gate-logo" />
        <div className="forge-gate-title brand-hue" data-testid="forge-gate-title">{gate.title || "BIENVENIDO"}</div>
        <div className="forge-gate-sub">{gate.subtitle || "A LA COMUNIDAD DE DIGITAL FORGE"}</div>
      </div>
    </div>
  );
};

export default ForgeGateHost;
